import { render, staticRenderFns } from "./ProductionPerformance.vue?vue&type=template&id=893751c0&scoped=true"
import script from "./ProductionPerformance.vue?vue&type=script&lang=js"
export * from "./ProductionPerformance.vue?vue&type=script&lang=js"
import style0 from "./ProductionPerformance.vue?vue&type=style&index=0&id=893751c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893751c0",
  null
  
)

export default component.exports